<style lang="scss" scoped>
.el-button {
  width: 60px;
  margin-left: 10px;
}
.table {
  background: #fff;
  height: 500px;
}
.blue {
  color: #173bcf;
}
.pager {
  text-align: center;
}
.pagination {
  padding-top: 15px;
}
/deep/ {
  .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background: transparent;
  }
}
</style>

<template>
  <div>
    <div>
      <el-date-picker
        v-model="value"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        format="dd/MM/yyyy"
      ></el-date-picker>
      <el-button size="mini" type="primary">查询</el-button>
    </div>
    <div class="clearfix mt20 mb20">
      <div class="fl">
        渠道名称:
        <span class="blue">ZP</span>
      </div>
      <a href class="fr blue">
        <i class="iconfont iconxiazai1"></i>下载表格
      </a>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" label="平台订单号"></el-table-column>
        <el-table-column prop="count" label="买家微信昵称"></el-table-column>
        <el-table-column prop="new" label="支付金额(元)"></el-table-column>
        <el-table-column prop="old" label="微信支付订单号"></el-table-column>
        <el-table-column prop="cancel" label="付款时间"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        class="pager"
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="currPage"
        :total="totalSize"
        @current-change="handlerChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data() {
    return {
      value: [],
      pageSize: 10,
      currPage: 1,
      totalSize: 100,
      tableData: [
        {
          date: '2019/05/24',
          count: 200,
          new: 60,
          old: 140,
          cancel: 4,
          id: 1,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handlerChange(iCurr) {
      console.log(iCurr);
    },
  },
};
</script>
